import { getAccessToken } from './auth-fn'
import {appConfig} from './config-api'

export {
    getBanners,
    updateBanner,
    removeBanner,
}

function getBanners () {
    return fetch(`${appConfig.backendUrl}/rest/banner/getall`)
      .then(response => {
          if (response.status === 200) {
              return response.json()
          }
          return Promise.reject(response)
      })
}

function updateBanner (data) {
    return fetch(`${appConfig.backendUrl}/worker/banner/save`, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    })
      .then(response => {
          if (response.status === 200) {
              return response.json()
          }
          return Promise.reject(response)
      })
}

function removeBanner (data) {
    return fetch(`${appConfig.backendUrl}/worker/banner/delete`, {
        method: 'POST',
        headers: {
            'authorization': `Bearer ${getAccessToken()}`,
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: data,
    })
      .then(response => {
          if (response.status === 200) {
              return true
          }
          return Promise.reject(response)
      })
}
